import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { typedMemo } from '@utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SettingsDialogProps {
  open: boolean;
  onClose: () => void;
}

export const SettingsDialog = typedMemo(
  ({ open, onClose }: Readonly<SettingsDialogProps>) => {
    const { t, i18n } = useTranslation();
    const [language, setLanguage] = useState(i18n.language ?? 'en');

    const handleLanguageChange = (event: SelectChangeEvent<string>) => {
      const newLang = event.target.value;
      setLanguage(newLang);
      i18n.changeLanguage(newLang);
      localStorage.setItem('Brz365.language', newLang);
      const isLocalhost =
        globalThis.location.hostname === 'localhost' ||
        globalThis.location.hostname === '127.0.0.1';
      if (isLocalhost) {
        document.cookie = `Brz365.language=${newLang};path=/;max-age=31536000`;
      } else {
        document.cookie = `Brz365.language=${newLang};domain=.brz365.eu;path=/;max-age=31536000`;
      }
    };

    return (
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>{t('userMenu.settings')}</DialogTitle>
        <DialogContent>
          <div style={{ marginTop: '0.375rem' }}>
            <FormControl fullWidth>
              <InputLabel>{t('userMenu.language')}</InputLabel>
              <Select
                value={language}
                label={t('userMenu.language')}
                onChange={handleLanguageChange}
                data-testid="language-select"
              >
                <MenuItem value="de">
                  {t('userMenu.languageGerman')}&nbsp;(DE)
                </MenuItem>
                <MenuItem value="en">
                  {t('userMenu.languageEnglish')}&nbsp;(US)
                </MenuItem>
                <MenuItem value="fr">
                  {t('userMenu.languageFrench')}&nbsp;(FR)
                </MenuItem>
              </Select>
            </FormControl>
          </div>
        </DialogContent>
      </Dialog>
    );
  },
);
